import IDealerBrandingDto from "./IDealerBranding";
import IDealerDto from "./IDealerDto";
import { DealerDto } from "./DealerDto";

export class DealerBrandingDto implements IDealerBrandingDto {
    public dealerBranding: IDealerDto = new DealerDto();
    public isListView = false;
    public hideChipplyLogo = false;
}
